






import { IEducationPlayerProps } from '@/componentsV2/molecules/EducationPlayer/EducationPlayer';
import flagKeys from '@/constants/flagKeys';
import eventBus from '@/utils/eventBus';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class EducationButton extends Vue {
  @Prop() educationVideo!: IEducationPlayerProps;

  get getFlags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get showTutorialButton() {
    return (
      this.educationVideo && this.getFlags.includes(flagKeys.videoEducation)
    );
  }

  get widthPlayer() {
    if (this.$mobileCheck()) return 332;

    return 382;
  }

  getOffset(el: HTMLDivElement) {
    const rect = el.getBoundingClientRect();

    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }

  onOpenVideo() {
    const offset = this.getOffset(document.querySelector(
      '.education-button'
    ) as HTMLDivElement);

    eventBus.$emit('openEducationPlayer', {
      ...this.educationVideo,
      offset
    });
  }

  mounted() {
    if (this.educationVideo && this.educationVideo.initialOpened)
      setTimeout(() => {
        this.onOpenVideo();
      }, 1000);
  }
}
